var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('list-input',_vm._b({on:{"item-changed":_vm.itemChanged},model:{value:(_vm.localvalue),callback:function ($$v) {_vm.localvalue=$$v},expression:"localvalue"}},'list-input',_vm.localFormItem,false))}
var staticRenderFns = []

export { render, staticRenderFns }